import {
	handleActions
} from 'redux-actions';
import Immutable from 'immutable';

const FittingBatchListState = Immutable.fromJS({
	fittingBatchList: [],
	activePage: 1,
	itemPerPage: 10,
	totalPage: 1
});

const fittingBatchListReducer = handleActions({
	FIND_FITTING_BATCH_LIST: (state, { payload }) => {
		return state.merge({
			fittingBatchList: payload.data.dataTableData,
			activePage: payload.data.activePage,
			totalPage: payload.data.totalPage,
			itemPerPage: payload.data.itemPerPage
		})
	},
	CHANGE_FITTING_BATCH_ACTIVE_PAGE:(state, { payload }) => {
		return state.merge({
			activePage: payload.activePage,
			itemPerPage: payload.itemPerPage
		})
	},
}, FittingBatchListState);

export default fittingBatchListReducer;


// WEBPACK FOOTER //
// ./src/reducers/fittingBatchListReducer.js